import { render, staticRenderFns } from "./myPersonal.vue?vue&type=template&id=3d5f88b8&scoped=true&"
import script from "./myPersonal.vue?vue&type=script&lang=js&"
export * from "./myPersonal.vue?vue&type=script&lang=js&"
import style0 from "./myPersonal.vue?vue&type=style&index=0&id=3d5f88b8&prod&lang=less&scoped=true&"
import style1 from "./myPersonal.vue?vue&type=style&index=1&id=3d5f88b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f88b8",
  null
  
)

export default component.exports